export function defineApiPostCall(api, routeName, definition, namespace, secure) {
    const httpCall = (values, params, options) => {
        const post = secure ? api.http.authenticatedPost : api.http.post;
        return post(definition.route, values, params, {
            headers: {
                ...definition.headers,
                ...options?.headers,
            },
            nativeProcessing: options?.nativeProcessing ?? definition.nativeProcessing,
            abortSignal: options?.abortSignal,
            method: options?.method ?? definition.method,
            mode: options?.mode ?? definition.mode ?? 'json',
            noStringify: options?.noStringify
        }).then(async (result) => {
            if (!result) {
                return result;
            }
            if (!definition.process) {
                return result.payload;
            }
            return await definition.process(result.payload, result.response);
        });
    };
    const apiCall = Object.assign(httpCall, {
        abortable: (abortSignal) => (values, params, options) => httpCall(values, params, {
            abortSignal: abortSignal,
            ...options,
        }),
    });
    const dynamic = api;
    if (!dynamic[namespace]) {
        dynamic[namespace] = {};
    }
    dynamic[namespace][routeName] = apiCall;
    return api;
}
